import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import '../theme/scss/app.scss';
import './scss/meepo.scss';
import Loader from '../components/common/loader';
import ProcessLoader from '../components/common/process-loader';
import Router from './router';

class MeepoApp extends React.Component {

    public render() {
        return (
            <div>
                <Loader/>
                <ProcessLoader/>
                <div>
                    <Router/>
                </div>
            </div>
        )
    }
}

export default MeepoApp;



// WEBPACK FOOTER //
// ./src/components/app.tsx